import styled from 'styled-components';
import { Hour } from '@modules/timetable';

const HoursContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: -12px;
  .hourly-block {
    width: 9px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .hour-count {
    font-size: 7px;
    position: relative;
    left: 4px;
  }
`;

// Get the hour labels generated
const hours: Hour[] = [];
for (let i = 1; i < 25; i += 1) {
  hours.push({ hour: i, label: i % 2 === 1 ? `0${i}`.slice(-2) : '' });
}

const TimelineHeaderHourIndicatorsGenerator = () => {
  return (
    <HoursContainer>
      {hours.map((hour) => (
        <div className="hourly-block" key={hour.hour}>
          <span className={hour.label !== '' ? 'hour-count' : ''}>{hour.label}</span>
        </div>
      ))}
    </HoursContainer>
  );
};

export const TimelineHeaderHourIndicatorsStatic = TimelineHeaderHourIndicatorsGenerator();
